module.exports = __webpack_public_path__ + "static/media/c49.1995f4d1.png";